import React from "react";
import PrimaryButtonWithArrow from "../../../components/Buttons/PrimaryButtonWithArrow/PrimaryButtonWithArrow";
import { FooterPollen } from "../../../assets/StaticQueries/FooterPollen.query";

import styles from "./PollenFooter.module.scss";

const PollenFooter = () => {
  const footerPollen = FooterPollen();

  return (
    <footer className={`full-width ${styles.blogFooterBanner}`}>
      <div className={styles.blogFooterCta}>
        <div className={styles.blogFooterCtaCopy}>
          <h2 className={`${styles.garamond} ${styles.blogFooterCtaTitle}`}>
            {footerPollen.pollenFooterCtaCopy}
          </h2>
        </div>
        <div className={styles.blogFooterCtaButton}>
          <PrimaryButtonWithArrow
            buttonText={footerPollen.pollenFooterCtaText}
            buttonLink={footerPollen.pollenFooterCtaLink}
          />
        </div>
      </div>
    </footer>
  );
};

export default PollenFooter;
